import { COLOR } from "../../../../common/Color"
import { Align } from "../../../../common/TextUtils"
import { ButtonContainer, Buttons } from "../../../generic-sprites/Buttons"
import { PhaserText, PhaserTextConfig } from "../../../utils/PhaserText"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { KidsChoicePartOneState } from "../KidsChoicePartOneState"
import { KidsChoiceCategoryType, KidsChoiceSprite } from "../KidsChoiceTypes"

export class KidsChoiceCategoryContainer implements KidsChoiceSprite {
    private readonly title: Phaser.Text
    private categories: Array<KidsChoiceCategory>

    constructor(game: Phaser.Game, group: Phaser.Group) {
        this.title = PhaserText.create(game, "The categories are", {
            group,
            color: COLOR.white,
            align: Align.CENTER
        })
        Sprites.centerTextInSprite(KidsChoicePartOneState.centerRectangle, this.title)
        this.title.y += Scale.y(0.05)
        this.categories = [
            new KidsChoiceCategory(game, KidsChoiceCategoryType.HEALTH_EFFECTS, group),
            new KidsChoiceCategory(game, KidsChoiceCategoryType.SECONDHAND_SMOKE, group)
        ]
    }

    addOnClick = (type: KidsChoiceCategoryType, onClick: () => void) => {
        const [category] = this.categories.filter(c => c.type === type)
        category.setOnClick(onClick)
    }

    enable = (type: KidsChoiceCategoryType) =>
        this.categories.filter(category => category.type === type).forEach(category => category.enable())

    disable = () => this.categories.forEach(category => category.disable())

    destroy = () => {
        this.title.destroy()
        this.categories.forEach(category => category.destroy())
    }
}

class KidsChoiceCategory implements KidsChoiceSprite {
    static textConfig: PhaserTextConfig = {
        wordWrapWidth: 0.25,
        align: Align.CENTER
    }

    category: ButtonContainer

    constructor(game: Phaser.Game, public type: KidsChoiceCategoryType, group: Phaser.Group) {
        this.category = Buttons.create(game, type, undefined, {
            debug: true,
            group,
            textConfig: KidsChoiceCategory.textConfig
        })
        this.category.button.width = this.category.text.width + Scale.x(0.02)
        this.category.button.height = this.category.text.height + Scale.y(0.02)
        Sprites.centerSpriteInSprite(KidsChoicePartOneState.centerRectangle, this.category.button)
        this.category.button.y += Scale.y(0.225)

        const delta = Scale.x(0.15)
        if (type === KidsChoiceCategoryType.HEALTH_EFFECTS) {
            this.category.button.x -= delta
        } else {
            this.category.button.x += delta
        }
        this.category.center()
    }

    setOnClick = (onClick: () => void) => this.category.setOnClick(onClick)

    disable = () => this.category.disable()

    enable = () => this.category.enable()

    destroy = () => this.category.destroy()
}
